/**
 * Loading bar
 */
init.$inject = ['$locationProvider', 'cfpLoadingBarProvider', '$httpProvider'];

function init ($locationProvider, cfpLoadingBarProvider, $httpProvider){
    $locationProvider.html5Mode(true);
    $httpProvider.defaults.headers.common["X-Requested-With"] = 'XMLHttpRequest';
}
